import { defineStore } from "pinia";
import { type AnalyticsEvent } from "@/types/Analytics";
import axios from "@/utils/axios";


export const useAnalyticsStore = defineStore("analytics_store", () => {
    const api_base = '/api/v1/analytics';

    const track_event = async (event: AnalyticsEvent) => {
        try {
            await axios.post(`${api_base}`, event);
        }
        catch (error) {
            console.error("Failed to track event");
        }
    }

    const track = async (message: string, name: string, namespace: string, description: string) => {
        const e: AnalyticsEvent = {
            data: { event: message },
            name: name,
            namespace: namespace,
            scope: "User",
            description: description
        };
        try {
            await track_event(e);
        }
        catch (error) {
            console.error("Failed to track event");
        }
    }

    return {
        track_event,
        track
    }
});